import { Alert, Snackbar } from "@mui/material";
import React, { createContext, useState } from "react";

interface SnackbarContextProps {
  showSnackbar: (message: string) => void;
  hideSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextProps>({
  showSnackbar: () => {},
  hideSnackbar: () => {},
});

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("testmessage");

  const showSnackbar = (message: string) => {
    setMessage(message);
    setOpen(true);
  };

  const hideSnackbar = () => {
    setOpen(false);
  };
  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          sx={{ "& .MuiAlert-icon": { display: "none" } }}
        >
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
